export const APP_NAME = 'Authorization Services';
export const DOCUMENT_TITLE_SEPARATOR = ' · ';
